import { Stack } from '@mui/material'
import { ReactNode } from 'react'

export interface TableContainerProps<T> {
    title?: ReactNode
    headerRow: ReactNode
    items: T[]
    renderItem: (item: T, idx: number) => ReactNode
    skeleton: ReactNode
    className?: string
}

export const TableContainer = <T extends object>({ title, headerRow, items, renderItem, skeleton, className }: TableContainerProps<T>) => {
    return (
        <div className={className ? className : ''}>
            {title ? <span className='pl-[16px] text-def font-bold text-white mb-[18px] block'>{title}</span> : null}

            <Stack spacing={1}>
                {headerRow}
                {items.length ? (
                    items.map(renderItem)
                ) : (
                    <>
                        {skeleton}
                        {skeleton}
                    </>
                )}
            </Stack>
        </div>
    )
}
